export const processFilters = value => {
  let selectedFilterObj = {};
  value?.filters?.forEach(item => {
    const filterValueArray = item?.filter_value
      ?.split(',')
      ?.map(value => parseInt(value));
    switch (item?.filterType?.type_name) {
      case 'store':
        selectedFilterObj.storeNumber = filterValueArray;
        break;
      case 'projectCategory':
        selectedFilterObj.projectCategoryId = filterValueArray;
        break;
      case 'projectType':
        selectedFilterObj.projectTypeId = filterValueArray;
        break;
      case 'status':
        selectedFilterObj.statusId = filterValueArray;
        break;
      case 'sourceStatus':
        selectedFilterObj.imsStatus = filterValueArray;
        break;
      case 'district':
        selectedFilterObj.districtId = [
          ...(item?.filter_value?.split(',') || []),
        ];
        break;
      case 'workroom':
        selectedFilterObj.workroomId = filterValueArray;
        break;
      case 'customer':
        selectedFilterObj.customerId = filterValueArray;
        break;
      case 'technician':
        selectedFilterObj.installerIds = filterValueArray;
        break;
      case 'company':
        selectedFilterObj.companyIds = filterValueArray;
        break;
      case 'teams':
        selectedFilterObj.teamsId = filterValueArray;
        break;
      case 'territory':
        selectedFilterObj.territoryIds = filterValueArray;
        break;
      default:
        break;
    }
  });

  return selectedFilterObj;
};

export const convertDefaultCustomerFormattingToFormikCustomerFormat = item => ({
  label: `${item.first_name} ${item.last_name} - ${item.primary_phone}`,
  id: item?.customer_id,
});

export const doCustomFieldsMatchDefaultFilter = values => {
  const selectedValues =
    values.defaultFilter?.selectedDefaultFiltersValues?.value || {};
  // filter fields that can be saved in the DB
  const defaultFields = [
    { formikKey: 'projectTypes', defaultKey: 'projectTypeList' },
    { formikKey: 'projectCategories', defaultKey: 'projectCategoryList' },
    { formikKey: 'stores', defaultKey: 'storeList' },
    { formikKey: 'projectStatus', defaultKey: 'statusList' },
    { formikKey: 'projectWorkrooms', defaultKey: 'workroomList' },
    { formikKey: 'techniciansVal', defaultKey: 'technicianList' },
    { formikKey: 'company', defaultKey: 'companyList' },
    { formikKey: 'team', defaultKey: 'teamList' },
    { formikKey: 'customers', defaultKey: 'customerList' },
    { formikKey: 'districtId', defaultKey: 'districtList' },
    { formikKey: 'sourceStatus', defaultKey: 'sourceStatusList' },
    { formikKey: 'territory', defaultKey: 'territoryList' },
  ];

  // If any other field (dates or userType) is selected, it's definitely a custom filter
  const otherFields = [
    'userType',
    'dateScheduledFilterStart',
    'dateScheduledFilterEnd',
    'dateCompletionFilterStart',
    'dateCompletionFilterEnd',
    'checkDateFromFilter',
    'checkDateToFilter',
    'dateSoldFromFilter',
    'dateSoldToFilter',
    'territory',
    'userCategory',
    'userSkillLevel',
  ];

  // Checking if any other field is populated, then its a custom filter
  for (const field of otherFields) {
    if (Array.isArray(values[field]) && values[field].length > 0) {
      return false;
    }
  }

  // Comparing default filter values with formik values
  for (const { formikKey, defaultKey } of defaultFields) {
    const formikValue = values[formikKey] || [];
    const defaultValue =
      (defaultKey === 'customerList'
        ? selectedValues[defaultKey]?.map(
            convertDefaultCustomerFormattingToFormikCustomerFormat
          )
        : selectedValues[defaultKey]) || [];
    if (
      formikValue.length !== defaultValue.length ||
      JSON.stringify(formikValue) !== JSON.stringify(defaultValue)
    ) {
      return false;
    }
  }
  return true;
};
